import { Component, Input, OnInit } from '@angular/core';
import { Article } from '../../models/knowledge-base';

@Component({
  selector: 'release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.css'],
  standalone: false
})
export class ReleaseNotesComponent implements OnInit {
  @Input() articles: Article[];

  constructor() {}

  ngOnInit(): void {}
}
